import axios from "axios";

// ============================================
// BASE URL CONFIGURATION
// ============================================

// Global backend URL (shared by all tools)
const GLOBAL_BASE_URL = process.env.REACT_APP_BE_URL || "https://uatapi.conasservices.com/1.0.1";

// Maintenance Planning tool backend URL (tool-specific)
// ✅ CHANGED: Remove the /v1/uat_mntplan/maintenance_planning part
const MAINT_PLANNING_BASE_URL =
  process.env.REACT_APP_MAINTENANCE_PLANNING_BACKEND_URL ||
  "https://devai.conasservices.com";  // ← Remove /1.0.1 and everything after

// ============================================
// AXIOS INSTANCES
// ============================================

// Global API client (used outside Maintenance Planning tool)
export const globalApi = axios.create({
  baseURL: GLOBAL_BASE_URL,
});

// Maintenance Planning API client (used only inside tool)
export const maintenancePlanningApi = axios.create({
  baseURL: MAINT_PLANNING_BASE_URL,
});

// ============================================
// AUTH TOKEN
// ============================================
const getToken = () => localStorage.getItem("token") || "";

// Attach token interceptor to Maintenance Planning API
maintenancePlanningApi.interceptors.request.use((config) => {
  config.headers["x-api-key"] = getToken();
  return config;
});

// Attach token interceptor to Global API
globalApi.interceptors.request.use((config) => {
  config.headers["x-api-key"] = getToken();
  return config;
});

// Rest of your code...
// ============================================
// ERROR HANDLER
// ============================================
const handleApiError = (error, fallbackMessage = "An error occurred") => {
  console.error("API Error:", error);

  if (error.response?.data?.status === "error") {
    throw error;
  }

  const status = error.response?.status;
  const data = error.response?.data;

  const errorMap = {
    400: { message: data?.message || "Invalid request", help: "Check your request data", error_type: "validation_error" },
    401: { message: "Authentication required", help: "Please log in again", error_type: "auth_error" },
    404: { message: "Resource not found", help: "Requested data not found", error_type: "not_found" },
    500: { message: "Server error", help: "Try again later", error_type: "server_error" },
  };

  throw {
    response: {
      data: {
        status: "error",
        ...(errorMap[status] || { message: fallbackMessage, help: "Server/network error", error_type: "server_error" }),
        details: data,
      },
    },
  };
};

export { handleApiError };